module.exports = __webpack_public_path__ + "static/media/official.00114012.svg";